export function LibertyAboutPage() {
  return (
    <section className="public-liberty-about" aria-labelledby="liberty-about-title">
      <div className="public-liberty-about-intro">
        <span className="public-section-kicker">About us</span>
        <h2 id="liberty-about-title">Built for family, community, and serious shooting sports.</h2>
        <p>
          Liberty Long Range is a premium, members-only shooting facility currently under development on
          75 acres of rural land in Liberty, Texas. Founded by Tony and Jennifer Simpson, the range is being
          built from the ground up with a strong focus on family, community, and excellence in shooting sports.
        </p>
      </div>

      <div className="public-liberty-about-grid">
        <article>
          <span>Facility plan</span>
          <p>
            Our facility will feature a 1,000-yard precision range, a 600-yard unknown-distance range,
            multiple 100-yard and 50-yard bays, a 180-degree tactical range, dedicated pistol and shotgun
            clay ranges, and spaces for training and competitions.
          </p>
        </article>
        <article>
          <span>Member experience</span>
          <p>
            We are committed to providing a safe, private, and professional environment where families,
            serious shooters, law enforcement, and enthusiasts can train, compete, and enjoy time together.
          </p>
        </article>
        <article>
          <span>Family membership</span>
          <p>
            Every membership at Liberty Long Range is a family membership, allowing spouses and children to
            shoot and participate in range activities. We believe shooting sports strengthen families and build
            lasting memories, which is why family involvement is at the heart of everything we do.
          </p>
        </article>
        <article>
          <span>Modern range technology</span>
          <p>
            With a strong emphasis on safety, quality, and community, Liberty Long Range is designed for
            members who value excellence in both facilities and experience. We are integrating modern
            technology with app-based reservations, automated drills, and performance tracking.
          </p>
        </article>
      </div>

      <div className="public-liberty-about-closing">
        <p>
          We also plan to add app-based target cameras, automated moving targets, and simulated and live-fire
          video simulators to the amenities available to our members.
        </p>
      </div>
    </section>
  );
}
